import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const PromoCTA = dynamic(() => import('./PromoCTA').then((m) => ({ default: m.PromoCTA })));

const PromoCTAConfig = {
  name: 'PromoCTA',
  friendlyName: 'Promo CTA',
  description: 'A promotional card with an icon, message, and call-to-action button on a purple background.',
  inputs: [
    {
      name: 'image',
      type: 'file',
      friendlyName: 'Icon / Illustration',
      helperText: 'Small image shown to the left of the message (e.g. a car illustration). Displays at 76 x 66 px.',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
    },
    {
      name: 'text',
      type: 'string',
      required: true,
      friendlyName: 'Message',
      defaultValue: 'Car been stolen or written off? You might need cover fast.',
      helperText: 'The bold white text next to the icon — keep it short and punchy (1–2 sentences).',
    },
    {
      name: 'buttonLabel',
      type: 'string',
      required: true,
      friendlyName: 'Button Text',
      defaultValue: 'Get a quote in minutes',
      helperText: 'Label on the call-to-action button.',
    },
    {
      name: 'buttonUrl',
      type: 'url',
      required: true,
      friendlyName: 'Button Link',
      defaultValue: 'https://www.tempcover.com/start-quote',
      helperText: 'Where the button takes the user when clicked.',
    },
    {
      name: 'buttonColor',
      type: 'string',
      friendlyName: 'Button Colour',
      enum: [
        { label: 'Orange (primary)', value: 'orange' },
        { label: 'Purple (secondary)', value: 'purple' },
      ],
      defaultValue: 'orange',
      helperText: 'Choose the button colour to match the campaign or page theme.',
    },
  ],
};

Builder.registerComponent(PromoCTA, PromoCTAConfig);
